module.exports = __webpack_public_path__ + "static/media/centro_medico_as.d64960d9.jpg";